import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Home2 } from './pages/Home2';
import { MarketIQ } from './pages/MarketIQ';
import { MarketIQHome } from './pages/MarketIQHome';
import { MarketIQPork } from './pages/MarketIQPork';
import { MarketIQChicken } from './pages/MarketIQChicken';
import { Article } from './pages/Article';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home2 data-id="element-3" />} data-id="element-2" />
        <Route path="/home1" element={<Home data-id="element-5" />} data-id="element-4" />
        <Route path="/market-iq" element={<MarketIQHome data-id="element-7" />} data-id="element-6" />
        <Route path="/market-iq/beef" element={<MarketIQ data-id="element-9" />} data-id="element-8" />
        <Route path="/market-iq/pork" element={<MarketIQPork data-id="element-11" />} data-id="element-10" />
        <Route path="/market-iq/chicken" element={<MarketIQChicken data-id="element-13" />} data-id="element-12" />
        <Route path="/article" element={<Article data-id="element-15" />} data-id="element-14" />
      </Routes>
    </BrowserRouter>;
}